import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { useAppContext } from "../../../libs/app-core/AppContext";
import {
  AppBar,
  Box,
  Checkbox,
  FormControlLabel,
  Grid,
  IconButton,
  Toolbar,
} from "@mui/material";
import {
  linear_content_style,
  linear_h,
  linear_item,
  linear_v,
} from "../../../libs/linear-layout/LinearLayout";
import AppMenuButton from "../../components/AppMenuButton";
import { R } from "../../R";
import Label from "../../../libs/rhf-mui/ui/Label";
import TabPage from "../../components/TabPage";
import { UniAnswerDAO } from "../../dao/UniAnswerDAO";
import { UniAnswer } from "../../dao/UniAnswer";
import { UiMetaTable } from "../FrmSpwkQuestV3/UiMetaTable";
import { UniFormDAO } from "../../dao/UniFormDAO";
import { SpwkUtil } from "../../dao/SpwkUtil";
import { UniInputDAO } from "../../dao/UniInputDAO";
import { UniOptionDAO } from "../../dao/UniOptionDAO";
import { UniQuestion } from "../../dao/UniQuestion";
import { UniQuestionDAO } from "../../dao/UniQuestionDAO";
import { new_ErrorAlert } from "../../export_spwk/ExportManager";
import { SpwkUtilV3 } from "../../dao/SpwkUtilV3";
import {
  DGV_LOCAL_TEXT,
  render_ToolTipCell,
  sx_icon_button,
} from "../../components/UIHelper";
import { UniForm } from "../../dao/UniForm";
import { F05_ExportData, F05_ExportManager } from "./F05_ExportManager";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import UcDgvCustomToolbar from "../../components/UcDgvCustomToolbar";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { Toast } from "../../../libs/app-core/Toast";
import UcDgvCustomPagination from "../../components/UcDgvCustomPagination";
import { useProject } from "../../dao/ProjectDAO";
import { useMemberList } from "../../dao/MemberDAO";
import { Project } from "../../dao/Project";
import { F04_ExportData, F04_ExportManager } from "./F04_ExportManager";
import { F01_ExportData, F01_ExportManager } from "./F01_ExportManager";
import { F02_ExportData, F02_ExportManager } from "./F02_ExportManager";
import { F03_ExportData, F03_ExportManager } from "./F03_ExportManager";
import { F06_ExportData, F06_ExportManager } from "./F06_ExportManager";
import { Member } from "../../dao/Member";
import LinearProgressWithLabel from "../../components/LinearProgressWithLabel";

export type FrmCommonExportParams = {
  project_guid: string;
  member_guid_list: string[];
};

type Props = {};

const FrmCommonExport = (props: Props) => {
  const [Progress, set_Progress] = useState(0);

  const [IsSaveCache, set_IsSaveCache] = useState(false);

  //#region 讀取網址參數
  let params = useLocation().state as FrmCommonExportParams;
  let project_guid: string = params.project_guid;
  let member_guid_list: string[] = params.member_guid_list ?? [];
  //#endregion

  if (project_guid == null) {
    throw new Error("project_guid==null!!!");
  }
  //-------------------------------------------------------
  const ctx = useAppContext();

  const { _Project } = useProject(project_guid);

  const { _MemberList } = useMemberList(project_guid);
  let sel_member_list: Member[] = _MemberList.filter((member) =>
    member_guid_list.includes(member.guid)
  );

  const [AppBarTabIndex] = useState("tab_快取樹狀圖");

  const [DataList, set_DataList] = useState<any[]>([]);

  const [AnsCnt, set_AnsCnt] = useState(0);
  const [CsvFileName, set_CsvFileName] = useState<string | undefined>(
    undefined
  );

  return render_MasterDetail();

  function render_MasterDetail() {
    return (
      <Box style={linear_content_style}>
        {/* 外框架 */}
        <Grid {...linear_h}>
          <Grid
            {...linear_item}
            bgcolor=""
            sx={{ width: 0 }}
            // sx={{ width: { xs: '160px', sm: '240px', xl: '360px' } }}
          >
            {/* 左側主檔 Master */}
            {render_Master()}
          </Grid>
          <Grid {...linear_item} flex={1} bgcolor="">
            {/* 中間列表 Details */}
            {render_Detail()}
          </Grid>
        </Grid>
      </Box>
    );
  }

  function render_Master() {
    /* 主檔: 左側答案選單 */
    return <div>render_Master()</div>;
  }

  function render_Detail() {
    /* 明細檔: 右側內容 */
    return (
      <>
        <Grid {...linear_v}>
          <Grid {...linear_item}>{render_AppBar()}</Grid>
          <Grid {...linear_item} flex={1}>
            {/* 上方特作篩選藥丸按鈕列表 */}
            <Grid {...linear_v}>{render_TabControl()}</Grid>
          </Grid>
        </Grid>
      </>
    );
  }

  function render_AppBar() {
    return (
      <>
        <AppBar position="static" sx={{ bgcolor: R.color.app_bar }}>
          <Toolbar variant="dense">
            <AppMenuButton label={render_AppTitle()} />
            <Box sx={{ flexGrow: 1 }}>{/* 填滿 ActionBar 剩餘空間 */}</Box>
            {render_ActionButtons()}
          </Toolbar>
        </AppBar>
        <Grid container>
          <Grid item sx={{ pl: 1 }}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={IsSaveCache}
                  onChange={(e) => {
                    set_IsSaveCache(e.target.checked);
                  }}
                />
              }
              label="保存F01、F05結果"
            />
          </Grid>
          <Grid item flex={1}>
            {IsSaveCache ? (
              <LinearProgressWithLabel progress={Progress} />
            ) : null}
          </Grid>
        </Grid>
      </>
    );
  }

  function render_AppTitle() {
    return (
      <div>
        <Label
          variant="body2"
          sx={{ p: 0, m: 0 }}
        >{`匯出4大計畫問卷CSV x${sel_member_list.length}人 x${AnsCnt}筆`}</Label>
      </div>
    );
  }

  function render_ActionButtons() {
    return (
      <div>
        <IconButton
          size={"small"}
          edge="start"
          color="inherit"
          sx={{ ...sx_icon_button, px: 1 }}
          onClick={() => {
            btn_一般問卷轉檔_Click(
              SpwkUtilV3.FORM_GUID_F01v0,
              _Project,
              sel_member_list
            );
          }}
        >
          F01 疲勞
        </IconButton>

        <IconButton
          size={"small"}
          edge="start"
          color="inherit"
          sx={{ ...sx_icon_button, px: 1 }}
          onClick={() => {
            btn_一般問卷轉檔_Click(
              SpwkUtilV3.FORM_GUID_F02v0,
              _Project,
              sel_member_list
            );
          }}
        >
          F02 心理
        </IconButton>

        <IconButton
          size={"small"}
          edge="start"
          color="inherit"
          sx={{ ...sx_icon_button, px: 1 }}
          onClick={() => {
            btn_一般問卷轉檔_Click(
              SpwkUtilV3.FORM_GUID_F03v0,
              _Project,
              sel_member_list
            );
          }}
        >
          F03 肌肉
        </IconButton>

        <IconButton
          size={"small"}
          edge="start"
          color="inherit"
          sx={{ ...sx_icon_button, px: 1 }}
          onClick={() => {
            btn_一般問卷轉檔_Click(
              SpwkUtilV3.FORM_GUID_F04v0,
              _Project,
              sel_member_list
            );
          }}
        >
          F04 工作適能(45+)
        </IconButton>
        <IconButton
          size={"small"}
          edge="start"
          color="inherit"
          sx={{ ...sx_icon_button, px: 1 }}
          onClick={() => {
            btn_一般問卷轉檔_Click(
              SpwkUtilV3.FORM_GUID_F05v0,
              _Project,
              sel_member_list
            );
          }}
        >
          F05 負荷
        </IconButton>
        <IconButton
          size={"small"}
          edge="start"
          color="inherit"
          sx={{ ...sx_icon_button, px: 1 }}
          onClick={() => {
            btn_一般問卷轉檔_Click(
              SpwkUtilV3.FORM_GUID_F06v0,
              _Project,
              sel_member_list
            );
          }}
        >
          F06 簡式
        </IconButton>
      </div>
    );
  }

  function render_TabControl() {
    return (
      <Box style={linear_content_style} sx={{}}>
        <TabPage
          tab_key={"tab_快取樹狀圖"}
          curr_tab={AppBarTabIndex}
          sx={{ bgcolor: "", height: "100%", overflow: "hidden" }}
        >
          {render_DataGrid()}
        </TabPage>
      </Box>
    );
  }

  function render_DataGrid(): React.ReactNode {
    const columns: GridColDef<any>[] = [];

    //#region 動態產生欄位
    if (DataList.length !== 0) {
      let data = DataList[0];

      let keys = Object.keys(data);

      for (const key of keys) {
        let col_def: GridColDef = {
          field: key,
          headerName: key,
          width: 150,
          description: "",
          editable: true,
          renderCell: render_ToolTipCell(),
        };

        columns.push(col_def);
      }
    }
    //#endregion

    const dataWithId = DataList.map((data, index) => ({
      ...data,
      id: index + 1,
    }));

    return (
      <div style={linear_content_style}>
        <DataGrid
          style={{ width: "100%", backgroundColor: "white", padding: "12px" }}
          rows={dataWithId}
          columns={columns}
          localeText={DGV_LOCAL_TEXT} // 中文
          components={{
            Toolbar: () => {
              return (
                <UcDgvCustomToolbar csv_file_name={CsvFileName}>
                  <IconButton
                    onClick={() => {
                      Toast.Show(ctx, "More");
                    }}
                  >
                    <MoreVertIcon />
                  </IconButton>
                </UcDgvCustomToolbar>
              );
            },
            Pagination: () => {
              return <UcDgvCustomPagination />;
            },
          }}
          density={"compact"}
          pageSize={100}
          rowsPerPageOptions={[100]}
          hideFooterSelectedRowCount
          // hideFooter

          onCellEditCommit={async ({ id, field, value }) => {}}
        />
      </div>
    );
  }

  /**
   * 找出指定 專案 x 指定一般問卷 x 指定 Members 的答案列表 (原則上應該是需要填寫就會有一張)
   */
  async function project_x_form_x_members_的答案列表_Async(
    project_guid: string,
    common_form_guid: string,
    member_guid_list: string[]
  ): Promise<UniAnswer[]> {
    let project_common_answer_list =
      await UniAnswerDAO.Select_指定場次的一般問卷答案列表(project_guid);
    let answer_list = project_common_answer_list.filter(
      (x) => x.form_guid === common_form_guid
    );
    // 至此篩選指定表單的答案

    let ans_list: UniAnswer[] = [];

    for (const member_guid of member_guid_list) {
      let finds = answer_list.filter(
        (x) => x.member_guid === member_guid && x.form_guid === common_form_guid
      );
      if (finds.length > 1) {
        console.log("finds:", finds);
        throw new_ErrorAlert(
          "1496487 預期應該要有剛好一筆 或 沒有 Answer !!! member_guid: " +
            member_guid
        );
      }

      if (finds.length > 0) {
        ans_list.push(finds[0]);
      }
    }

    return ans_list;
  }

  async function 取得_common_form_樹狀結構_Async(
    common_form_guid: string
  ): Promise<UniForm | null> {
    let form_guid_list = [common_form_guid];

    const cache_forms = await UniFormDAO.WS_SelectForms_ByFormGuidList(
      form_guid_list
    );
    const cache_questions =
      await UniQuestionDAO.WS_SelectQuestions_ByFormGuidList(form_guid_list);
    const cache_options = await UniOptionDAO.WS_SelectOptions_ByFormGuidList(
      form_guid_list
    );
    const cache_inputs = await UniInputDAO.DB_SelectInputs_ByFormGuidList(
      form_guid_list
    );

    /* 填好樹狀結構 $$$ 核心方法 */
    UniFormDAO.FillFormTree(
      cache_forms,
      cache_questions,
      cache_options,
      cache_inputs
    );

    const common_form =
      cache_forms.find((x) => x.guid === common_form_guid) ?? null;

    return common_form;
  }

  function ConvertToUiMetaTable(common_form: UniForm): UiMetaTable {
    //-------------------------------------------------------
    let meta_table = new UiMetaTable();

    let chapters: string[] = [];
    if (common_form.AllQuestions != null) {
      chapters = chapters.concat(
        common_form.AllQuestions.map((x) => x.chapter)
      );
    }

    chapters = chapters.filter(
      (value, index, array) => array.indexOf(value) === index
    ); // 不重複的

    for (const chapter of chapters) {
      let questions: UniQuestion[] = SpwkUtil.GetChapterQuestionsV3(
        chapter,
        common_form,
        []
      );

      let meta_list = UiMetaTable.ConvertQuestionToMetaList(questions);

      meta_table.ConcatMetaList(meta_list);
    }

    return meta_table;
  }

  async function btn_一般問卷轉檔_Click(
    common_form_guid: string,
    _Project: Project | null,
    sel_member_list: Member[]
  ) {
    // alert("TODO 應該用選的");

    if (_Project == null) {
      return;
    }

    set_Progress(0);

    let answer_list = await project_x_form_x_members_的答案列表_Async(
      project_guid,
      common_form_guid,
      member_guid_list
    );

    let common_form = await 取得_common_form_樹狀結構_Async(common_form_guid);

    if (common_form == null) {
      throw new_ErrorAlert("1464131 找不到指定的一般問卷");
    }

    let meta_table = ConvertToUiMetaTable(common_form);

    if (common_form_guid === SpwkUtilV3.FORM_GUID_F01v0) {
      let export_list: F01_ExportData[] = await F01_ExportManager.Export_F01v0(
        IsSaveCache,
        set_Progress,
        common_form,
        meta_table,
        answer_list,
        _Project,
        sel_member_list
      );
      set_DataList(export_list);
      set_AnsCnt(export_list.length);
      set_CsvFileName(
        "F01工作負荷程度 - " + ToLegalFileName(_Project.project_name)
      );
    } else if (common_form_guid === SpwkUtilV3.FORM_GUID_F02v0) {
      let export_list: F02_ExportData[] = F02_ExportManager.Export_F02v0(
        common_form,
        meta_table,
        answer_list,
        _Project,
        sel_member_list
      );
      set_DataList(export_list);
      set_AnsCnt(export_list.length);
      set_CsvFileName(
        "F02心理健康量表 - " + ToLegalFileName(_Project.project_name)
      );
    } else if (common_form_guid === SpwkUtilV3.FORM_GUID_F03v0) {
      let export_list: F03_ExportData[] = F03_ExportManager.Export_F03v0(
        common_form,
        meta_table,
        answer_list,
        _Project,
        sel_member_list
      );
      set_DataList(export_list);
      set_AnsCnt(export_list.length);
      set_CsvFileName(
        "F03肌肉骨骼 - " + ToLegalFileName(_Project.project_name)
      );
    } else if (common_form_guid === SpwkUtilV3.FORM_GUID_F04v0) {
      let export_list: F04_ExportData[] = F04_ExportManager.Export_F04v0(
        common_form,
        meta_table,
        answer_list,
        _Project,
        sel_member_list
      );
      set_DataList(export_list);
      set_AnsCnt(export_list.length);
      set_CsvFileName(
        "F04工作適能(45歲以上) - " + ToLegalFileName(_Project.project_name)
      );
    } else if (common_form_guid === SpwkUtilV3.FORM_GUID_F05v0) {
      let export_list: F05_ExportData[] = await F05_ExportManager.Export_F05v0(
        IsSaveCache,
        set_Progress,
        common_form,
        meta_table,
        answer_list,
        _Project,
        sel_member_list
      );
      set_DataList(export_list);
      set_AnsCnt(export_list.length);
      set_CsvFileName(
        "F05工作型態調查 - " + ToLegalFileName(_Project.project_name)
      );
    } else if (common_form_guid === SpwkUtilV3.FORM_GUID_F06v0) {
      let export_list: F06_ExportData[] = await F06_ExportManager.Export_F06v0(
        common_form,
        meta_table,
        answer_list,
        _Project,
        sel_member_list
      );
      set_DataList(export_list);
      set_AnsCnt(export_list.length);
      set_CsvFileName(
        "F06簡式健康量表 - " + ToLegalFileName(_Project.project_name)
      );
    } else {
      throw new_ErrorAlert("64941698 未知的轉檔方式 !!!");
    }
  }
};

export default FrmCommonExport;

export function ToLegalFileName(str: string): string {
  // 檔案名稱不可以包含下列任意字元: \/:*?"<>|
  let re: string = str
    .replaceAll("\\", "＼")
    .replaceAll("/", "／")
    .replaceAll(":", "：")
    .replaceAll("*", "＊")
    .replaceAll("?", "？")
    .replaceAll('"', "〃")
    .replaceAll("<", "〈")
    .replaceAll(">", "〉")
    .replaceAll("|", "｜")
    .replaceAll("[", "〔") // EXCEL 不可以有中括號
    .replaceAll("]", "〕");
  return re;
}
